// NotFound.jsx
import React from "react";
import { Layout, Result, Button } from "antd";
import { Link } from "react-router-dom";
import "./NotFound.css";

const { Content } = Layout;

const NotFound = ({ loggedInUser, onLogout }) => {
  return (
    <Content className="blog-content notfound-content">
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={
          <Link to="/">
            <Button type="primary">返回首页</Button>
          </Link>
        }
      />
    </Content>
  );
};

export default NotFound;
